import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { FamilyMembersPort } from '@domain/service/family-members.port';
import {
  CreateFamilyMemberData,
  CreateFamilyMembersRequest,
  CreateFamilyMembersResponse
} from '@model/family-member/create-family-members.model';
import { AppHttpClientApi } from '@helpers/api/http-client-api';

// Re-export for backward compatibility
export type {
  CreateFamilyMemberData,
  CreateFamilyMembersRequest,
  CreateFamilyMembersResponse
};
// Alias for backward compatibility
export type FamilyMemberData = CreateFamilyMemberData;

@Injectable({
  providedIn: 'root'
})
export class FamilyMembersService implements FamilyMembersPort {
  private readonly http = inject(AppHttpClientApi);

  createFamilyMembers(
    request: CreateFamilyMembersRequest
  ): Observable<CreateFamilyMembersResponse> {
    return this.http.postRaw<CreateFamilyMembersResponse>(
      'orders/create-family-members',
      request
    );
  }
}
